<!--Agent Card-->

<div *ngIf="AgentDTO$ | async as AgentDTO" class="AgentCard">

    <!--Browser Mode - (non-mobile)-->
    <div class="d-none d-md-block">
        <div class="Vert-20"></div>

        <!-- No co-branding (single agent) -->
        <div class="row" *ngIf="!ShowingTwoAgents">
            <div class="col-xl-5 col-lg-6 col-md-8 col-sm-12">
                <div class="float-left">
                    <img [src]="AgentDTO.agentInfo.profileImageUrl | LgvDefaultAgentImage" style="width:125px;" />
                </div>
                <div class="float-left" style="margin-left:20px;">
                    <div class="name">{{AgentDTO.agentInfo.firstName}} {{AgentDTO.agentInfo.lastName}}</div>
                    <div *ngIf="AgentDTO.agentInfo.jobTitle" class="jobTitle">{{AgentDTO.agentInfo.jobTitle}}</div>
                    <div *ngIf="AgentDTO.agentInfo.licenseNumber">License # {{AgentDTO.agentInfo.licenseNumber}}</div>
                    <div *ngIf="AgentDTO.agentInfo.nmlsid">NMLS # {{AgentDTO.agentInfo.nmlsid}}</div>

                    <div class="Vert-30" *ngIf="AgentDTO.agentInfo.address1"></div>

                    <div *ngIf="AgentDTO.agentInfo.address1">{{AgentDTO.agentInfo.address1}}</div>
                    <div *ngIf="AgentDTO.agentInfo.city">{{AgentDTO.agentInfo.city}}<span *ngIf="AgentDTO.agentInfo.city && AgentDTO.agentInfo.city.length > 0">, </span>{{AgentDTO.agentInfo.state}} {{AgentDTO.agentInfo.zip}}</div>
                </div>
                
            </div>
            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12">
                <div *ngIf="!IsPublicZone"><a (click)="OnSendEmail()">Email me</a></div>
                <div><a *ngIf="!(LgvUserSvc.IsPrelicensedAgent$ | async)" [href]="AgentSafeURL$ | async" target="_blank">Visit my website</a></div>
                <div class="Vert-10"></div>
                <div class="clearfix"><div *ngIf="AgentDTO.agentInfo.phone" class="phoneIcon float-left"><div style="margin-top:-4px;">p</div></div> <div class="float-left">{{AgentDTO.agentInfo.phone | LgvPhoneNumber}}</div></div>
                <div class="clearfix"><div *ngIf="AgentDTO.agentInfo.mobilePhone" class="phoneIcon float-left"><div style="margin-top:-2px;">c</div></div> <div class="float-left">{{AgentDTO.agentInfo.mobilePhone | LgvPhoneNumber}}</div></div>
                <div class="clearfix"><div *ngIf="AgentDTO.agentInfo.fax" class="phoneIcon float-left"><div style="margin-top:-2px;">f</div></div> <div class="float-left">{{AgentDTO.agentInfo.fax | LgvPhoneNumber}}</div></div>
            </div>

        </div>

        <!--co-branding-->
        <div class="row co-branding" *ngIf="ShowingTwoAgents">
            <div class="agent-footer">
                <div class="image-container">
                    <img class="image" [src]="AgentDTO.agentInfo.profileImageUrl | LgvDefaultAgentImage" />
                    <div class="info">
                            <div class="name mb-2">{{AgentDTO.agentInfo.firstName}} {{AgentDTO.agentInfo.lastName}}</div>
                            <div class="jobTitle">{{AgentDTO.agentInfo.jobTitle}}</div>
                            <div *ngIf="AgentDTO.agentInfo.licenseNumber && ((IsRealtor$ | async) || !(LgvUserSvc.IsPrelicensedAgent$ | async))">License # {{AgentDTO.agentInfo.licenseNumber}}</div>
                            <div *ngIf="!(IsRealtor$ | async) && !AgentDTO.agentInfo.ckUser">NMLS # {{AgentDTO.agentInfo.nmlsid}}</div>
        
                            <div class="Vert-7"></div>
                           
                            <div *ngIf="!AgentDTO?.agentInfo?.ckUser" style="color: #6D6D6D">
                                <br>
                                <span style="font-weight: 500; font-size: 14px;">{{AgentDTO.company.name}}</span><br>
                                <span style="font-size: 12px;">{{AgentDTO.agentInfo.address1}}</span><br>
                                <span style="font-size: 12px;">{{AgentDTO.agentInfo.city}}</span>
                                <span *ngIf="AgentDTO.agentInfo.city && AgentDTO.agentInfo.city.length > 0">, </span> <br>
                                <span style="font-size: 12px;">{{AgentDTO.agentInfo.state}} {{AgentDTO.agentInfo.zip}}</span>
                            </div>
                            <div *ngIf="!!AgentDTO?.agentInfo?.ckUser" style="color: #6D6D6D">
                                <br>
                                <span style="font-weight: 500; font-size: 14px;">Real-Finity Mortgage, LLC</span><br>
                                <span style="font-size: 12px;">929 Alton Road Suite 500, Miami, FL 33139</span>
                            </div>
                      
                    </div>
                </div>
                <div class="detail">
                    <div *ngIf="!IsPublicZone"><a (click)="OnSendEmail()">Email me</a></div>
                    <div><a *ngIf="!AgentDTO.agentInfo.ckUser" [href]="AgentSafeURL$ | async" target="_blank">Visit my website</a></div>
                    <div class="Vert-7"></div>
                    <div class="clearfix" >
                        <div *ngIf="AgentDTO.agentInfo.phone" class="phoneIcon float-left">
                            <div style="margin-top:-2px;">p</div>
                        </div>
                        <div class="float-left">{{AgentDTO.agentInfo.phone | LgvPhoneNumber}}</div>
                    </div>
                    <div class="clearfix">
                        <div *ngIf="AgentDTO.agentInfo.mobilePhone" class="phoneIcon float-left">
                            <div style="margin-top:0px;">c</div>
                        </div>
                        <div class="float-left">{{AgentDTO.agentInfo.mobilePhone | LgvPhoneNumber}}
                        </div>
                    </div>
                    <div class="clearfix"><div *ngIf="AgentDTO.agentInfo.fax" class="phoneIcon float-left">
                        <div style="margin-top:0px;">f</div>
                    </div>
                    <div class="float-left">{{AgentDTO.agentInfo.fax | LgvPhoneNumber}}</div>
                </div>
            </div>
        </div>
            
        </div>

    </div>


    <!--Mobile (Either Co-Branded or Normal) -->
    <div class="d-md-none">
        <div class="row" style="padding: 20px;">
            <div class="col-12 name">{{AgentDTO.agentInfo.firstName}} {{AgentDTO.agentInfo.lastName}}</div>
            <div class="col-12 jobTitle">{{AgentDTO.agentInfo.jobTitle}}</div>
            <div class="col-12 Vert-7"></div>
            <div class="col-6">
                <img [src]="AgentDTO.agentInfo.profileImageUrl | LgvDefaultAgentImage" style="width:125px;" />
            </div>
            <div class="col-6">
                <div class="clearfix" *ngIf="AgentDTO.agentInfo.phone">
                    <div class="phoneIcon float-left">
                        <div style="margin-top:-4px;">p</div>
                    </div>
                    <div class="float-left">{{AgentDTO.agentInfo.phone | LgvPhoneNumber}}</div>
                </div>
                <div class="clearfix" *ngIf="AgentDTO.agentInfo.mobilePhone">
                    <div class="phoneIcon float-left">
                        <div style="margin-top:-2px;">c</div>
                    </div>
                    <div class="float-left">{{AgentDTO.agentInfo.mobilePhone | LgvPhoneNumber}}</div>
                </div>
                <div class="clearfix" *ngIf="AgentDTO.agentInfo.fax">
                    <div class="phoneIcon float-left">
                        <div style="margin-top:-2px;">f</div>
                    </div>
                    <div class="float-left">{{AgentDTO.agentInfo.fax | LgvPhoneNumber}}</div>
                </div>
                <div class="Vert-7"></div>
                <div *ngIf="!IsPublicZone"><a (click)="OnSendEmail()">Email me</a></div>
            </div>
        </div>
    </div>


    <div class="Vert-10"></div>

</div>
